module.exports = __webpack_public_path__ + "img/object_two.d7d28073.png";